export interface LayoutProps {
  isLoading: boolean
  children: React.ReactNode
}

export const useLayout = (props: LayoutProps) => {
  return {
    ...props,
  }
}
